if (!customElements.get('ondelie-faq')) {
  class OndelieFaq extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-of-item]'));

      this.items.forEach((item, index) => {
        const trigger = item.querySelector('[data-of-trigger]');
        if (trigger) trigger.addEventListener('click', () => this.toggle(index));
      });

      this.addEventListener('shopify:block:select', (event) => {
        const item = event.target.closest('[data-of-item]');
        const index = this.items.indexOf(item);
        if (index >= 0) this.open(index);
      });

      this.mountReveal();
    }

    toggle(index) {
      const item = this.items[index];
      const activeIndex = item && item.classList.contains('is-open') ? -1 : index;
      this.open(activeIndex);
    }

    open(activeIndex) {
      this.items.forEach((item, index) => {
        const isOpen = index === activeIndex;
        const trigger = item.querySelector('[data-of-trigger]');
        const panel = item.querySelector('[data-of-panel]');

        item.classList.toggle('is-open', isOpen);
        if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (panel) panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      });
    }

    mountReveal() {
      this.classList.add('is-mounted');

      if (!('IntersectionObserver' in window)) {
        this.classList.add('is-visible');
        return;
      }

      this.revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

      this.revealObserver.observe(this);
    }

    disconnectedCallback() {
      if (this.revealObserver) this.revealObserver.disconnect();
    }
  }

  customElements.define('ondelie-faq', OndelieFaq);
}
